document.addEventListener("DOMContentLoaded", () => {

    const trigger = document.querySelector(".login-search-trigger");
    const popup = document.querySelector(".login-search-popup");
    const overlay = document.querySelector(".login-search-overlay");
    const closeBtn = document.querySelector(".login-search-close");
    const input = document.querySelector(".login-search-input");

    if (!trigger || !popup) return;

    // Open Popup
trigger.addEventListener("click", function(e){
    e.preventDefault();
    
    // Scrollbar ki width calculate karein
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    
    // Body ko fix karein aur margin-right dein
    document.body.style.overflow = "hidden";
    document.body.style.marginRight = scrollbarWidth + "px";
    
    popup.classList.add("active");

    setTimeout(() => {
        input.focus();
    }, 200);
});

// Close Popup
function closePopup(){
    popup.classList.remove("active");
    
    // Reset karein
    document.body.style.overflow = "";
    document.body.style.marginRight = "";
}

    // Close Button
    closeBtn.addEventListener("click", closePopup);

    // Overlay Click
    overlay.addEventListener("click", closePopup);

    // ESC Key
    document.addEventListener("keydown", function(e){

        if(e.key === "Escape"){

            closePopup();

        }

    });

});


/*===============================
LIVE AJAX SEARCH
================================*/

const searchInput = document.querySelector(".login-search-input");
const liveResults = document.querySelector(".login-live-results");
const defaultArea = document.querySelector(".login-search-default");

if (searchInput) {

    let timer;

    searchInput.addEventListener("input", function () {

        clearTimeout(timer);

        const query = this.value.trim();

        if (query.length < 2) {

            liveResults.classList.remove("active");
            defaultArea.classList.remove("hide");
            liveResults.innerHTML = "";

            return;

        }

        timer = setTimeout(() => {

            fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=8`)

                .then(res => res.json())

                .then(data => {

                    const products = data.resources.results.products;

                    liveResults.innerHTML = "";

                    defaultArea.classList.add("hide");
                    liveResults.classList.add("active");

                    if (!products.length) {

                        liveResults.innerHTML =
                            `<p>No products found.</p>`;

                        return;

                    }

                    products.forEach(product => {

                        liveResults.innerHTML += `

<a href="${product.url}" class="search-product-card">

<img src="${product.featured_image.url}&width=500">

<div class="search-product-info">

<h4>${product.title}</h4>

<div class="search-product-price">

${product.price}

</div>

</div>

</a>

`;

                    });

                });

        }, 250);

    });

}